import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';

const HeroParallax = () => {
  return (
    <div className='h-[660px] lg:h-[580px] md:h-[550px] sm:h-[500px] xs:h-[380px] overflow-hidden relative'>
      <div className='absolute top-0 left-0 w-full h-full bg-darkgray opacity-30 z-[1]'></div>
      <Parallax
        className='lg-no-parallax bg-cover absolute -top-[50px] left-0 w-full h-[100vh] z-0 lg:-top-[70px] md:h-[600px] md:-top-[50px] xs:h-[450px]'
        translateY={[-40, 40]}
        style={{
          backgroundImage: `url(assets/img/services/ocean-lading.jpg)`,
        }}
      ></Parallax>
      <Container className='h-full relative z-[2]'>
        <Row className='justify-center h-full'>
          <Col
            xl={6}
            lg={7}
            md={8}
            className='relative font-serif text-center flex justify-center flex-col'
          >
            <h1 className='text-white opacity-60 mb-[20px] text-xmd leading-[20px]'>
              Ocean freight services
            </h1>
            <h2 className='text-white font-medium -tracking-[1px] mb-0'>
              FCL and LCL across global trades
            </h2>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroParallax;
